export default __webpack_public_path__ + "static/media/port-logo-pvn.7048ebd3.webp";